module.exports = __webpack_public_path__ + "static/media/empty.361da580.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/empty.svg
// module id = 1104
// module chunks = 1